<template>
    <div class="wrapper">
        <ResultHeader />
        <main class="container">
            <div class="row">
                <ResultSummaryCard 
                    :img="getKaoImageFolderPath() + getSummary(level, score).img"
                    :remark="getSummary(level, score).remark" 
                    :description="getSummary(level, score).description" 
                    :resultSummaryCard="body.resultSummaryCard" />
                <ResultScoreCard :score="score" :args="body.resultScoreCard" />
                <ResultGraph :data="makeData" />
            </div>
            <div class="row row-eq-height">
                <ResultCategoryCard v-for="(category, i) in buildCategoryCard(level, answers)" 
                    :key="i" :category="category" :args="body.resultCategoryCard" />
            </div>
        </main>
        <ModalIntro :id="0" />
        <ModalShare :id="0" :remark="remark" />
    </div>
</template>

<script>
import ResultHeader from './Result/ResultHeader'
import ResultSummaryCard from './Result//ResultSummaryCard'
import ResultScoreCard from './Result/ResultScoreCard'
import ResultCategoryCard from './Result/ResultCategoryCard'
import ModalIntro from './ModalIntro'
import ModalShare from './ModalShare'
import ResultGraph from './Result/ResultGraph'
import query from '../assets/js/query'
import result from '../assets/json/result'

export default {
    props: [
        'level',
    ],
    data: function() {
        return {
            result: result
        }
    },
    components: {
        ResultHeader,
        ResultSummaryCard,
        ResultScoreCard,
        ResultCategoryCard,
        ModalIntro,
        ModalShare,
        ResultGraph,
    },
    computed: {
        /* 点数計算 */
        score: function() { 
            return this.calScore(this.$props.level, this.answers);
        },
        /* クエリ形式の回答を配列に変換する */
        answers: function() {
            return query.queryStr2Array(this.$route.query.a);
        },
        body: function() {
            if(window.location.href.includes("-en")) {
                return result.en;
            }else if(window.location.href.includes("-cn")) {
                return result.cn;
            }else if(window.location.href.includes("-pt")) {
                return result.pt;
            }else if(window.location.href.includes("-sn")) {
                return result.sn;
            }else if(window.location.href.includes("-tg")) {
                return result.tg;
            }else{
                return result.jp;
            }
            
        },
        /* グラフ用データの生成 */
        makeData: function() {
            const array = [];
            const categories = this.getCategories(this.$props.level);
            const scores = this.calcScores(this.$props.level, this.answers);
            const maxScores = this.calcMaxScores(this.$props.level);
            array.push(['Category', '%', { role: 'style' }]);
            for(var i=0; i<categories.length; i++){
                const title = categories[i].text;
                const percent = scores[i] * 100 / maxScores[i];
                array.push( [title, percent, 'orchid']);
            }
            return array;
        }
        
    },
    created: function () {
    }
}
</script>

<style>
    .card {
        margin-top: 16px;
        margin-bottom: 16px;
    }

    .modal-dialog{
        min-width: 100%;
        max-width: 100%;
        margin: 0;
    }
</style>